<template>
  <div class="col d-flex flex-column justify-content-center align-items-center"
       style="flex: auto; overflow-y:auto;height: 100vh"
  >

    <div class="d-flex flex-column p-4 rounded-lg shadow-lg" style="background-color: white; width: 400px">
      <div id="top-info" class="col d-flex flex-column align-items-center mb-3">
        <span class="font-weight-bold">Digite a nova senha abaixo</span>
      </div>

      <fieldset :disabled="loading">
        <form @submit.stop.prevent="submit()" class="needs-validation">
          <div class="form-group">
            <b-form-input
              required
              type="password"
              class="form-control rounded-1"
              id="senha"
              name="senha"
              placeholder="Nova senha"
              v-model="form.senha"
              :state="validation.senha"
            />
          </div>
          <div class="form-group">
            <b-form-input
              required
              type="password"
              class="form-control rounded-1"
              id="confirmar-senha"
              name="confirmar-senha"
              placeholder="Confirmar nova senha"
              v-model="form.confirmarSenha"
              :state="validation.confirmarSenha"
            />
            <div class="invalid-feedback">
              As senhas informadas não são iguais.
            </div>
          </div>
          <div class="form-group">
            <b-btn
              class="btn btn-secondary p-2 w-100 font-weight-bold"
              style=" color: white"
              type="submit"
            >
              <font-awesome-icon
                v-if="loading"
                spin
                :icon="['fas', 'circle-notch']"
              >
              </font-awesome-icon>
              Definir nova senha
            </b-btn>
          </div>
        </form>
      </fieldset>
    </div>
  </div>
</template>

<script>
import { axiosInstance as Axios } from "@/main";

export default {
  name: "recuperar-senha",
  computed: {
    actual() {
      return this.$store.getters.actual;
    },
    go() {
      return this.$store.getters.to;
    },
    user() {
      return this.$store.getters.user;
    },
    to() {
      return this.$store.getters.to;
    },
    urls() {
      return this.$store.getters.urls;
    }
  },
  mounted() {
    this.token = new URLSearchParams(window.location.search).get("token");
  },
  data() {
    return {
      loading: false,
      token: null,
      validation: {
        confirmarSenha: null
      },
      form: {
        senha: null,
        confirmarSenha: null
      }
    };
  },
  methods: {
    submit: async function () {
      if (this.form.senha !== this.form.confirmarSenha) {
        this.validation.confirmarSenha = false;
        return;
      }

      let payload = {
        url: `${this.$serverHost}auth/trocar-senha`,
        token: this.token,
        novaSenha: this.form.senha
      };

      try {
        this.loading = true;
        await Axios.post(`${payload.url}`, payload);

        const mensagem =
          "A senha foi atualizada. Já é possível fazer login utilizando as novas credenciais.";
        this.$bvToast.toast(mensagem, {
          title: "Sucesso",
          variant: "success",
          autoHideDelay: 10000,
          appendToast: true
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
